<p-toast></p-toast>
<div class="card">
    <div class="card-text flex justify-content-center">
        <p>{{ "APPLICATION_STATUS" | translate }}</p>
    </div>
    <div class="p-fluid p-formgrid flex justify-content-center vendor-info px-2 my-4 appeal-data py-1"
        style="display: flex; flex-wrap:wrap">
        <div class="field md:col-4 col-12">
            <label>{{'VENDOR_NAME'| translate}}</label>
            <input class="info-data" readonly value="{{ appealData?.Vendor_Name }}" pInputText id="Status"
                type="text" />
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'MOBILE_NO'| translate}}</label>
            <input class="info-data" readonly value="{{ appealData?.Mobile }}" pInputText id="Status" type="text" />
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'EMAIL_ID'| translate}}</label>
            <input class="info-data" readonly value="{{ appealData?.Email_ID }}" pInputText id="Status" type="text" />
        </div>
        <div class="field md:col-4 col-12">
            <label>{{ "STATUS" | translate }}</label>
            <input class="info-data-imp" readonly value="{{ appealData?.Status }}" pInputText id="Status" type="text" />
        </div>
        <div class="field md:col-4 col-12">
            <label>{{ "REMARK" | translate }}</label>
            <input class="info-data-imp" readonly value="{{ appealData?.remarks }}" pInputText id="Status"
                type="text" />
        </div>
    </div>

    <div *ngIf="appealData?.Status == 'Objection Raised'" class="document-upload-section">

        <div class="attachment-card">
            <div class="field col-12 md:col-12 sub-heading flex justify-content-center">
                <p>{{ 'ATTACHMENT_DETAILS' | translate }}</p>
            </div>
            <div class="p-fluid p-formgrid grid flex justify-content-around grid mt-1">
                <div class="field col-12 md:col-3" *ngFor="let item of uploadOptions; let i = index">
                    <label>{{ item.DocType | translate }}</label>
                    <p *ngIf="item.Attachments">
                        <a style="cursor: pointer" [href]="item.Attachments" target="_blank">{{ 'View Doc' | translate
                            }}</a>
                    </p>
                </div>
                <!-- <p class="invalid-feedback" *ngIf="uploadOptions && uploadOptions.length < 1">
                    {{ imageError }}
                </p> -->
            </div>
        </div>

        <hr style="border: 1px dashed rgb(118, 117, 117);">

        <!-- <div class="document-upload-section"> -->
        <form [formGroup]="vendorForm">
            <div class="p-fluid p-formgrid justify-content-center vendor-info" style="display: flex; flex-wrap:wrap">
                <!-- Document Type Dropdown -->
                <div class="field col-12 md:col-4">
                    <label for="documentType">Document Type</label>
                    <!-- <p-dropdown id="documentType" [options]="vendorAttachmentData" formControlName="documentType" -->
                    <!-- optionLabel="Doc_Type" placeholder="Select Document Type" [showClear]="true"> -->
                    <p-dropdown id="documentType" [options]="uploadOptions" formControlName="documentType"
                        optionLabel="DocType" placeholder="Select Document Type" [showClear]="true">
                    </p-dropdown>
                    <div *ngIf="vendorForm.get('documentType').invalid && vendorForm.get('documentType').touched"
                        class="error">
                        <small *ngIf="vendorForm.get('documentType').errors?.['required']">Document Type is
                            required.</small>
                    </div>
                </div>

                <!-- File Upload -->
                <div class="field col-12 md:col-4">
                    <label for="fileUpload">Upload Document</label>
                    <p-fileUpload accept=".pdf" #grievanceCopyPath [customUpload]="true"
                        [disabled]="vendorForm.invalid || vendorForm.get('documentType').invalid"
                        (uploadHandler)="onUpload($event, 'grievanceCopyPath', grievanceCopyPath)" name="myfile[]"
                        mode="basic" [maxFileSize]="5000000" cho oseLabel="Browse" [auto]="true">
                    </p-fileUpload>
                </div>

                <div class="field col-12 md:col-12">
                    <div class="document-list" style="display: flex; flex-wrap:wrap;">
                        <!-- <label for="description">Document Updated Successfully</label> -->
                        <div class="field col-12 md:col-12 document p-fluid p-formgrid grid mt-2"
                            *ngFor="let item of documentList; let i=index">
                            <div class="mr-2 px-2 py-2 update-doc-box">
                                <span>
                                    <br>
                                    <p style="margin-bottom: 0;" target="_blank" class="mx-4"> {{item.documentType ?
                                        item.documentType:
                                        item.DocumentType}} Updated Successfully.</p>
                                    <!-- <i class="pi pi-times cross-icon" style="color: red; cursor: pointer;"
                                        (click)="removeCaptureImg(i)"></i> -->
                                    <!-- </span> -->
                                    <img *ngIf="isImage(item.attachmentsDoc || item.ImagePath); else pdfTemplate"
                                        [src]="item.attachmentsDoc ? item.attachmentsDoc : item.ImagePath"
                                        style="max-width: 300px; max-height: 300px; display: block;">
                                    <p *ngIf="isImage(item.attachmentsDoc || item.ImagePath)">
                                        <a style="cursor: pointer" [href]="item.attachmentsDoc"
                                            target="_blank">{{'VIEW_DOC' |
                                            translate}}</a>
                                    </p>
                                    <ng-template #pdfTemplate>
                                        <a style="display: flex; justify-content: center; min-width: 120px"
                                            [href]="item.attachmentsDoc ? item.attachmentsDoc : item.ImagePath"
                                            target="_blank">
                                            View PDF
                                        </a>
                                    </ng-template>
                                </span>
                            </div>
                        </div>

                        <div *ngIf="documentList.length > 0"
                            class="field col-12 md:col-12 flex justify-content-center mt-3">
                            <button pButton pRipple label="{{ 'SUBMIT' | translate }}" class="p-button-success text-md"
                                style="width: auto;" (click)="onSubmitUpdateDoc()"></button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>